__turbopack_context__.v({
  "change_station_panel": "cxdByG_change_station_panel",
  "change_station_panel__buttons": "cxdByG_change_station_panel__buttons",
  "change_station_panel__header": "cxdByG_change_station_panel__header",
  "change_station_panel__stations_list": "cxdByG_change_station_panel__stations_list",
});
